// extracted by mini-css-extract-plugin
module.exports = {"switchButton":"MyOrdersButton_switchButton__7K2cT"};